module.exports = __webpack_public_path__ + "img/sprinkle-18.54d3b90c.jpg";